import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalBar } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import 'chartjs-plugin-datalabels';

function StudentsDistributionChart(props) {
  const { t, classesNames, occupation, capacity } = props;

  const data = {
    labels: classesNames,
    datasets: [
      {
        backgroundColor: '#9c2dd2',
        label: t(
          'dashboard.occupationBoard.charts.studentsDistribution.legends.occupation'
        ),
        borderColor: '#9c2dd2',
        borderWidth: 1,
        hoverBackgroundColor: '#9c2dd2',
        hoverBorderColor: '#9c2dd2',
        data: occupation,
      },
      {
        backgroundColor: '#E7E7ED',
        label: t(
          'dashboard.occupationBoard.charts.studentsDistribution.legends.capacity'
        ),
        borderColor: '#E7E7ED',
        borderWidth: 1,
        hoverBackgroundColor: '#E7E7ED',
        hoverBorderColor: '#E7E7ED',
        data: capacity,
      },
    ],
  };

  const options = {
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
    scales: {
      xAxes: [
        {
          stacked: false,
        },
      ],

      yAxes: [
        {
          stacked: false,
        },
      ],
    },
    maintainAspectRatio: false,

    plugins: {
      datalabels: false,
    },
  };

  return <HorizontalBar data={data} options={options} />;
}

StudentsDistributionChart.propTypes = {
  t: PropTypes.func.isRequired,
  classesNames: PropTypes.arrayOf(PropTypes.shape),
  occupation: PropTypes.arrayOf(PropTypes.shape),
  capacity: PropTypes.arrayOf(PropTypes.shape),
};

StudentsDistributionChart.defaultProps = {
  classesNames: [],
  occupation: [],
  capacity: [],
};

export default withTranslation('common')(StudentsDistributionChart);
